import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Router, ActivatedRoute } from "@angular/router";
import { BsModalService } from "ngx-bootstrap/modal";
import { ShopItemsService } from "./shopitems.service";
import { AlertService, BaseMaterialDatatableComponent, ConfirmDialogComponent } from "@impacgroup/angular-baselib";
import { ShopItem } from "../../api-models/ShopItem";
import { ShopItemsMainComponent } from "./shopitems.main.component";
import { PermissionService } from "@impacgroup/angular-oauth-base";

@Component({
    selector: "app-shopitems",
    templateUrl: "./shopitems.component.html",
    styleUrls: ["shopitems.component.scss"],
    standalone: false
})
export class ShopItemsComponent extends BaseMaterialDatatableComponent<ShopItem> implements OnInit {
    public UTCDATEFORMAT: string = "";

    rows: ShopItem[] = [];
    hasEditPermissions: boolean = false;

    constructor(
        private shopItemsService: ShopItemsService,
        private translateService: TranslateService,
        private permissionService: PermissionService,
        private router: Router,
        private route: ActivatedRoute,
        private modalService: BsModalService,
        private alertService: AlertService,
        parent: ShopItemsMainComponent
    ) {
        super({
            stateSaveConfig: {
                stateSaveMode: shopItemsService.datatableStateSaveMode,
                stateSaveComponent: parent,
                stateSaveStorageKey: "dtstate_shop_items_list"
            },
            sortState: {
                active: "materialNumber",
                direction: "asc"
            },
            displayedColumns: ["name", "materialNumber", "category", "inactive", "created", "updated", "actions"],
            listService: shopItemsService
        });

        this.UTCDATEFORMAT = this.shopItemsService.UTCDATEFORMAT;
        this.hasEditPermissions = this.permissionService.hasPermission("SHOPITEMS.EDIT");
    }

    addShopItem() {
        this.router.navigate(["add"], { relativeTo: this.route });
    }

    editShopItem(id: string) {
        this.router.navigate([id], { relativeTo: this.route });
    }

    deleteShopItem(id: string) {
        const initialState = {
            title: this.translateService.instant("shopitems.list.delete.title"),
            message: this.translateService.instant("shopitems.list.delete.message"),
            closeBtnName: this.translateService.instant("global.buttons.close"),
            confirmBtnName: this.translateService.instant("global.buttons.ok")
        };
        const bsModalRef = this.modalService.show(ConfirmDialogComponent, { initialState });
        bsModalRef.content.confirmCallback = () => {
            this.subscriptions.push(
                this.shopItemsService.deleteShopItem(id).subscribe((result) => {
                    this.alertService.addSuccess(this.translateService.instant("shopitems.list.delete.success"));
                    this.loadData();
                })
            );
        };
    }

    onInactiveToggle(item: ShopItem) {
        item.inactive = !item.inactive;
        this.subscriptions.push(
            this.shopItemsService.updateShopItem(item).subscribe({
                next: () => {
                    this.loadData();
                    this.alertService.addSuccess(this.translateService.instant("shopitems.detail.edit.success"));
                },
                error: (err) => {
                    this.alertService.addError(err);
                }
            })
        );
    }
}
